import { DeepLinkType, IDeepLink } from '@gem/models/deeplinksModel';

import { DeepLink, DeepLink_Type } from 'APP/wsApi/wsAppApi/types/deeplink/deeplink_model_pb';

export const deeplinkB2bResponseTypeMap: Record<DeepLink_Type, DeepLinkType> = {
  [DeepLink_Type.CHAT_INVITE]: DeepLinkType.Group,
  [DeepLink_Type.MESSAGE]: DeepLinkType.Message,
  [DeepLink_Type.CALL_INVITE]: DeepLinkType.Call,
  [DeepLink_Type.UNKNOWN]: DeepLinkType.Unknown,
  [DeepLink_Type.ROOM]: DeepLinkType.Room,
};

export const mapB2bDeepLinkResponse = (data: DeepLink): IDeepLink => {
  return {
    ...data,
    parentId: data.parentId ? String(data.parentId) : undefined,
    entityId: String(data.entityId),
    type: deeplinkB2bResponseTypeMap[data.type],
  };
};
